module.exports = "<ui-view></ui-view>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/service/service.html
// module id = 554
// module chunks = 0